import styled from '@emotion/styled';
import { List } from '@qga/roo-ui/components';
import { space } from 'styled-system';

import done from './assets/done.svg';

const TickedList = styled(List)`
  ${space}
  list-style-image: url(${done});
`;

export default TickedList;
